// extracted by mini-css-extract-plugin
export default {"container":"styles_container__USZy2","headertext":"styles_headertext__nZKaa","contentMain":"styles_contentMain__VAB8a","textOne":"styles_textOne__YX+nc","img":"styles_img__RV3Jz"};